// extracted by mini-css-extract-plugin
export default {"scrollArrowWrapper":"_ScrollArrow_scrollArrowWrapper__OG9Kh","scrollArrowImg":"_ScrollArrow_scrollArrowImg__rHbg2","scrollArrowText":"_ScrollArrow_scrollArrowText__3txn5"};